/* eslint-disable max-len */
import React from 'react';

var IconBroadcast = function IconBroadcast() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 4.5V1C14 0.45 13.55 0 13 0H1C0.45 0 0 0.45 0 1V11C0 11.55 0.45 12 1 12H13C13.55 12 14 11.55 14 11V7.5L17.1464 10.6464C17.4614 10.9614 18 10.7383 18 10.2929V1.70711C18 1.26165 17.4614 1.03857 17.1464 1.35355L14 4.5Z",
    fill: "#E90000"
  }));
};

export default IconBroadcast;